import { Component } from '@angular/core';

@Component({
    selector: 'app-create-app-title-bar',
    templateUrl: './create-app-title-bar.component.html',
    styleUrls: ['./create-app-title-bar.component.scss'],
    standalone: false
})
export class CreateAppTitleBarComponent {}
